export default function truncate(s, n) {
  return s && s.length > n ? `${s.slice(0, n - 3)}...` : s;
}
